import React, { useState, useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";
import "./styles.css";

const Accordion = ({ title, children, type = "full-border", forceOpen }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (forceOpen !== undefined) {
      setIsOpen(forceOpen);
    }
  }, [forceOpen]);

  const getTypeClass = () => {
    if (type === "border-bottom") return "accordion-border-bottom";
    if (type === "without-border") return "accordion-without-border";
    return "accordion-full-border";
  };

  const typeClass = getTypeClass();
  const isIconLeft = type === "without-border";
  const headerClass = `accordion-header ${isIconLeft ? "accordion-header-icon-left" : ""}`;

  const getIconRotation = () => {
    if (isIconLeft) {
      return isOpen ? "rotate(0deg)" : "rotate(-90deg)";
    }
    return isOpen ? "rotate(180deg)" : "rotate(0deg)";
  };

  const icon = (
    <span
      className="accordion-icon"
      style={{
        transform: getIconRotation(),
      }}
    >
      <FaAngleDown/>
    </span>
  );

  return (
    <div className={`accordion-container ${typeClass}`}>
      <div
        className={headerClass}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isIconLeft && icon}
        {title}
        {!isIconLeft && icon}
      </div>
      <div
        className={`accordion-content ${isOpen ? "accordion-content-open" : ""}`}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;